<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">“You stay out here while I clear the place. I’m sure the burglar’s long gone, but it doesn’t hurt to be safe.”</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Danny couldn’t help but watch as the man ran up the stairs. He had a superb ass. All of him was pretty superb, actually. Now that his panic was receding, Danny could actually appreciate the way the officer’s slacks and button-down couldn’t quite hide how nicely built he was. His face was attractive too.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">And he was supernatural. He’d sniffed out that Danny was a werewolf immediately, but Danny couldn’t place the officer’s scent. He definitely wasn’t a werewolf. He smelled earthy, like a shifter, but not anything Danny could pin down.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">He heard the cop thundering down the stairs a few flights before he saw him, and he was ready when the man burst out of the door. He motioned Danny up the stairs.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Danny followed the detective inside.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?3c906ee8